import React from "react";
import axios from "axios";
import { Col, Row, Skeleton, Drawer, Icon, Divider, Switch, Tabs } from "antd";
import Main from "../GoogleMap/Main";
import { withTranslation } from "react-i18next";
import LatestTask from "../Dashboard/LatestTasks";
import Comments from "../Comments/CommentList";

const { TabPane } = Tabs;

const DescriptionItem = ({ title, content }) => (
  <div
    style={{
      fontSize: 14,
      lineHeight: "22px",
      marginBottom: 7,
      color: "rgba(0,0,0,0.65)",
    }}
  >
    <p
      style={{
        marginRight: 8,
        display: "inline-block",
        color: "rgba(0,0,0,0.85)",
      }}
    >
      {title}:
    </p>
    {content}
  </div>
);

class LeadPreview extends React.Component {
  state = {
    data: {},
  };

  componentDidMount() {
    let token = localStorage.getItem("token");
    axios.defaults.xsrfCookieName = "csrftoken";
    axios.defaults.xsrfHeaderName = "X_CSRFTOKEN";
    axios.defaults.headers = {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("language"),
      Authorization: `Token ${token}`,
    };
  }

  onClose = () => {
    this.props.handleState("visible", false);
    // this.setState({
    //     visible: false,
    // });
  };

  render() {
    let fullWidth = global.window.innerWidth;
    if (fullWidth > 1000) fullWidth = fullWidth / 2;
    // const places = [{
    //     id: this.props.singleData.id,
    //     name: this.props.singleData.name,
    //     lat: parseFloat(this.props.singleData.lat),
    //     lng: parseFloat(this.props.singleData.lng)
    // }];
    const { t, singleData } = this.props;

    return (
      <div>
        <Drawer
          width={fullWidth}
          placement="right"
          closable={true}
          onClose={this.onClose}
          visible={this.props.visible}
        >
          {this.props.loading ? (
            <Skeleton active loading={this.props.singleLoading} />
          ) : (
            <div>
              <Tabs defaultActiveKey="1" onChange={(e) => console.log(e)}>
                <TabPane
                  tab={
                    <span>
                      <Icon type="exclamation-circle" />{" "}
                      {t("leads.lead_form.lead_info", "Lead information")}
                    </span>
                  }
                  key="1"
                >
                  <p className="pStyle">
                    {t("leads.lead_form.company", "Company")}
                  </p>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.company_name",
                          "Company name"
                        )}
                        content={this.props.singleData.name}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.full_name", "Full name")}
                        content={this.props.singleData.full_name}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.email", "Email")}
                        content={this.props.singleData.email}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.phone", "Phone")}
                        content={this.props.singleData.phone}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.siret", "Siret")}
                        content={this.props.singleData.siret}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.job", "Job")}
                        content={this.props.singleData.metier}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.siren", "Siren")}
                        content={this.props.singleData.siren}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.creation_of_business",
                          "Creation of business"
                        )}
                        content={this.props.singleData.creation_of_business}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={6}>
                      <DescriptionItem
                        title={t("leads.lead_form.workforce", "Workforce")}
                        content={this.props.singleData.workforce}
                      />
                    </Col>
                    <Col span={6}>
                      <DescriptionItem
                        title={t("leads.lead_form.circulation", "Circulation")}
                        content={this.props.singleData.circulation}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.other_names",
                          "Other company names"
                        )}
                        content={this.props.singleData.other_names}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.contacts", "Contacts")}
                        content={
                          this.props.singleData.contacts
                            ? this.props.singleData.contacts.map((item) => {
                                return (
                                  item.first_name + " " + item.last_name + ", "
                                );
                              })
                            : ""
                        }
                      />
                    </Col>
                    {/* <Col span={12}>
                                        <DescriptionItem title="Creation of business" content={this.props.singleData.created_by_scrapping} />
                                    </Col> */}
                  </Row>

                  <Row>
                    <Col span={24}>
                      <DescriptionItem
                        title={t("leads.lead_form.websites", "Websites")}
                        content={this.props.singleData.website}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.agency_website",
                          "Agency Website"
                        )}
                        content={this.props.singleData.agency_website}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <DescriptionItem
                        title={t("leads.lead_form.description", "Description")}
                        content={this.props.singleData.description}
                      />
                    </Col>
                  </Row>
                  <Divider />
                  <p className="pStyle">
                    {t("leads.lead_form.location", "Location")}
                  </p>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.address", "Address")}
                        content={this.props.singleData.address}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.city", "City")}
                        content={this.props.singleData.city}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.post_code", "Postal code")}
                        content={this.props.singleData.post_code}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.country", "Country")}
                        content={this.props.singleData.country}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.region_level_one",
                          "Smaller region"
                        )}
                        content={this.props.singleData.region_level_one}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.region_level_two",
                          "Bigger region"
                        )}
                        content={this.props.singleData.region_level_two}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <Main
                        lat={this.props.singleData.lat}
                        lng={this.props.singleData.lng}
                        single={true}
                        name={this.props.singleData.name}
                        id={this.props.singleData.id}
                      />
                    </Col>
                  </Row>
                  <Divider />
                  <p className="pStyle">
                    {t(
                      "leads.lead_form.business_analysis",
                      "Business analysis"
                    )}
                  </p>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.natural_seo", "Natural SEO")}
                        content={this.props.singleData.natural_seo}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.local_seo", "Local SEO")}
                        content={this.props.singleData.local_seo}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.advertising", "Advertising")}
                        content={
                          this.props.singleData.advertising
                            ? this.props.singleData.advertising.map((item) => {
                                return item.name + ", ";
                              })
                            : ""
                        }
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.keywords", "Keywords")}
                        content={this.props.singleData.keywords}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.proposal", "Proposal")}
                        content={this.props.singleData.proposal}
                      />
                    </Col>
                  </Row>
                  {/*  */}
                  <Divider />
                  <p className="pStyle">
                    {t("leads.lead_form.extra_info", "Extra information")}
                  </p>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.status", "Status")}
                        content={this.props.singleData.status_display}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.source", "Source")}
                        content={this.props.singleData.source_display}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.assigned_to", "Assigned to")}
                        content={
                          this.props.singleData.assigned_to
                            ? this.props.singleData.assigned_to.map((item) => {
                                return (
                                  item.first_name + " " + item.last_name + ", "
                                );
                              })
                            : ""
                        }
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.created_by", "Created by")}
                        content={
                          this.props.singleData.created_by
                            ? this.props.singleData.created_by["first_name"] +
                              " " +
                              this.props.singleData.created_by["last_name"]
                            : ""
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.created_on", "Created on")}
                        content={this.props.singleData.created_on}
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.is_active", "Is active?")}
                        content={
                          <Switch
                            disabled={true}
                            checked={this.props.singleData.is_active}
                          />
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <DescriptionItem
                        title={t("leads.lead_form.tags", "Tags")}
                        content={
                          this.props.singleData.tags
                            ? this.props.singleData.tags.map((item) => {
                                return item.name + ", ";
                              })
                            : ""
                        }
                      />
                    </Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.created_by_scraping",
                          "Created by scraping?"
                        )}
                        content={
                          <Switch
                            disabled={true}
                            checked={this.props.singleData.created_by_scrapping}
                          />
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}></Col>
                    <Col span={12}>
                      <DescriptionItem
                        title={t(
                          "leads.lead_form.check_for_domain",
                          "Check for domain expirity?"
                        )}
                        content={
                          <Switch
                            disabled={true}
                            checked={
                              this.props.singleData.check_for_domain_expirity
                            }
                          />
                        }
                      />
                    </Col>
                  </Row>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="check-square" />{" "}
                      {t("layout.menu.tasks", "Tasks")}
                    </span>
                  }
                  key="2"
                >
                  <LatestTask
                    t={t}
                    tasksLatest={singleData.tasks}
                    hiddenLead={true}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="wechat" />{" "}
                      {t("leads.lead_form_sidebar.comments", "Comments")}
                    </span>
                  }
                  key="3"
                >
                  <Comments t={t} comments={singleData.comments} />
                </TabPane>
              </Tabs>
            </div>
          )}
        </Drawer>
      </div>
    );
  }
}

export default withTranslation()(LeadPreview);



// WEBPACK FOOTER //
// ./src/containers/Leads/LeadPreview.js